import * as common from './common';

export default {
  common,
};
